import React from 'react'
import NProgress from 'react-nprogress'

import TutorialFilterSidebar from './Components/TutorialFilterSidebar'
import TutorialSearch from './Components/TutorialSearch'
import TutorialCard from './Components/TutorialCard'
import PaginationSection from '../Shared/Paginator/Paginator'

export default class TutorialsSection extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      didFetchData: false,
      isMobileFilterOpen: false,
      categories: [],
      software: [],
      tutorials: [],
      users: [],
      meta: {
        totalPages: 0,
        currentPage: 1,
        totalCount: 0,
      },
      fetchData: {
        text: '',
        sort: 'latest',
        page: props.page || 1,
        categories: props.category ? [props.category] : [],
        software: props.software ? [props.software] : [],
      },
    }

    this.onFetchDataFailure = this.onFetchDataFailure.bind(this)
    this.onFetchTutorialSuccess = this.onFetchTutorialSuccess.bind(this)
    this.onCategoryChange = this.onCategoryChange.bind(this)
    this.onSoftwareChange = this.onSoftwareChange.bind(this)
    this.onSearchSubmit = this.onSearchSubmit.bind(this)
    this.onSortFilterClick = this.onSortFilterClick.bind(this)
    this.onPaginate = this.onPaginate.bind(this)
    this.handleMobileFiltersToggle = this.handleMobileFiltersToggle.bind(this)
  }

  componentDidMount() {
    return this._fetchTutorials({})
  }

  onFetchCategoriesSuccess(response) {
    return this.setState({
      categories: response.data.data,
    })
  }

  _fetchTutorials() {
    NProgress.start(true)

    return axios
      .get('/tutorials/search', { params: this.state.fetchData })
      .then(this.onFetchTutorialSuccess)
      .catch(this.onFetchDataFailure)
  }

  onFetchTutorialSuccess(response) {
    NProgress.done()

    this.setState({
      didFetchData: true,
      tutorials: response.data.data,
      meta: response.data.meta,
      users: response.data.included,
    })

    this._refreshFilterSection()
  }

  _refreshFilterSection() {
    this.setState({
      categories: this.state.meta.activeCategoryFilters.data,
      software: this.state.meta.activeSoftwareFilters.data,
    })
  }

  onFetchDataFailure(xhr, status, err) {}

  onSearchSubmit(text) {
    this.state.fetchData.text = text

    this._resetPagination()
    return this._fetchTutorials()
  }

  onSortFilterClick(sort) {
    this.state.fetchData.sort = sort
    this._resetPagination()

    return this._fetchTutorials()
  }

  onPaginate(pageNumber) {
    this.state.fetchData.page = pageNumber

    return this._fetchTutorials()
  }

  onCategoryChange(category, selected) {
    if (selected) {
      this._addCategoryFilter(category)
      this._resetPagination()
    } else {
      this._removeCategoryFilter(category)
    }

    this._updateHeadingTitle()
    this._updateCurrentUrl()
    return this._fetchTutorials()
  }

  onSoftwareChange(software, selected) {
    if (selected) {
      this._addSoftwareFilter(software)
      this._resetPagination()
    } else {
      this._removeSoftwareFilter(software)
    }

    this._updateHeadingTitle()
    this._updateCurrentUrl()
    return this._fetchTutorials()
  }

  _resetPagination() {
    return (this.state.fetchData.page = 1)
  }

  _addCategoryFilter(category) {
    return this.state.fetchData.categories.push(category)
  }

  _addSoftwareFilter(software) {
    return this.state.fetchData.software.push(software)
  }

  _removeCategoryFilter(category) {
    const index = this.state.fetchData.categories.indexOf(category)
    return this.state.fetchData.categories.splice(index, 1)
  }

  _removeSoftwareFilter(software) {
    const index = this.state.fetchData.software.indexOf(software)
    return this.state.fetchData.software.splice(index, 1)
  }

  _updateHeadingTitle() {
    const titleElements = []
    if (this.state.fetchData.software.length === 1) titleElements.push(this.state.fetchData.software[0])
    if (this.state.fetchData.categories.length === 1) titleElements.push(this.state.fetchData.categories[0])
    titleElements.push('Tutorials')

    document.getElementsByClassName(
      'content-heading__title'
    )[0].innerHTML = titleElements.join(' ')
    document.title = `${titleElements.join(' ')} | CGTrader`
  }

  _updateCurrentUrl() {
    const urlElements = ['/tutorials']
    if (this.state.fetchData.software.length === 1) {
      urlElements.push('software')
      urlElements.push(
        this.state.fetchData.software[0].replace(/\s+/g, '-').toLowerCase()
      )
    }
    if (this.state.fetchData.categories.length === 1) {
      urlElements.push('category')
      urlElements.push(
        this.state.fetchData.categories[0].replace(/\s+/g, '-').toLowerCase()
      )
    }

    const url = urlElements.join('/')
    history.pushState({ url }, '', url)
  }

  handleMobileFiltersToggle() {
    if (this.state.isMobileFilterOpen) {
      document.body.classList.remove('is-overlaid')
      const mobileCurtains = document.getElementById('mobile-curtains')
      mobileCurtains.classList.remove('is-active')
      mobileCurtains.onclick = undefined
    } else {
      document.body.classList.add('is-overlaid')
      const mobileCurtains = document.getElementById('mobile-curtains')
      mobileCurtains.classList.add('is-active')
      mobileCurtains.onclick = this.handleMobileFiltersToggle
    }

    this.setState({
      isMobileFilterOpen: !this.state.isMobileFilterOpen,
    })
  }

  render() {
    const users = this.state.users

    const cardsNode = this.state.tutorials.map((tutorial) => {
      const user = users.find(
        user => user.id === tutorial.relationships.user.data.id
      )

      return <TutorialCard key={tutorial.id} data={tutorial} user={user} />
    })

    const noDataNode = (
      <div className="warning">
        <h4 className="warning-text">No tutorials found...</h4>
      </div>
    )

    return (
      <div className="row">
        <div className="col-sm-12 col-md-3">
          <TutorialFilterSidebar
            categories={this.state.categories}
            software={this.state.software}
            selectedCategories={this.state.fetchData.categories}
            selectedSoftware={this.state.fetchData.software}
            onCategoryFilterChange={this.onCategoryChange}
            onSoftwareFilterChange={this.onSoftwareChange}
            isMobileFilterOpen={this.state.isMobileFilterOpen}
            onMobileFiltersClick={this.handleMobileFiltersToggle}
          />
        </div>
        <div className="col-sm-12 col-md-9">
          <TutorialSearch
            onFormSubmit={this.onSearchSubmit}
            onSortFilterClick={this.onSortFilterClick}
            onMobileFiltersClick={this.handleMobileFiltersToggle}
          />
          <div className="tutorials__container">
            {this.state.tutorials.length > 0 ? cardsNode : noDataNode}
            <PaginationSection
              totalPages={this.state.meta.totalPages}
              currentPage={this.state.meta.currentPage}
              onPaginate={this.onPaginate}
              useHistoryApi
            />
          </div>
        </div>
      </div>
    )
  }
}
